import * as Sentry from '@sentry/react';
import { message } from 'antd';
import cookie from 'js-cookie';
import { CONFIG_SERVER } from '../constants/common.constant';
import {
  TOKEN,
  REFRESH_TOKEN,
  PERMISSION_TOKEN,
  PERMISSIONS,
} from '../constants/auth.constant';
import { getTenantSetting } from '../apis/auth.api';
import { cookieStorageAction } from '@vindr/utils/helpers/storage';

const { CLIENT_ID, AUTH_URL, RESPONSE_TYPE, STATE, REALM_ID } = CONFIG_SERVER;

export const requestLogin = (isRedirect) => {
  const realmId = REALM_ID;
  const pathAuth = AUTH_URL + `/auth/realms/${realmId}/protocol/openid-connect/auth`;

  let loginUrl =
    pathAuth + '?client_id=' + CLIENT_ID + '&response_type=' + RESPONSE_TYPE + '&state=' + STATE;

  if (isRedirect) {
    loginUrl += '&redirect_uri=' + window.location.origin;
    sessionStorage.setItem('redirect_uri', window.location.href);
  }

  window.location.href = encodeURI(loginUrl);
};

export const actionLogout = async () => {
  try {
    cookie.remove(REFRESH_TOKEN);
    cookie.remove(TOKEN);
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(PERMISSION_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    sessionStorage.removeItem(PERMISSIONS);
    cookieStorageAction.clear();

    let realmId = REALM_ID;

    if (!realmId) {
      const res = await getTenantSetting();
      if (res && res.data && res.data.realm_id) {
        realmId = res.data.realm_id;
      }
    }

    if (realmId) {
      const url =
        AUTH_URL +
        `/auth/realms/${realmId}/protocol/openid-connect/logout?redirect_uri=${window.origin}`;
      window.location.href = url;
    } else {
      message.error('Can not get tenant info!');
    }
  } catch (error) {
    Sentry.captureException(error);
    console.error('actionLogout: ', error);
  }
};
